//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedTemplate.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[],[[["user_defined_template_instantiation"],"CreateInstantiationBuilder",{R_:{builder:"UserDefinedTemplate.InstantiationBuilder"}},1,0],[["journal_identifier"],"FindObject",{R_:{found:"TaggedObject"}},1,1],[["user_defined_template_definition"],"CreateDefinitionBuilder",{R_:{builder:"UserDefinedTemplate.DefinitionBuilder"}},1,0],[["journal_identifier"],"FindInstantiationObject",{R_:{result:"UserDefinedTemplate.Instantiation"}},1,0],[["journal_identifier"],"FindDefinitionObject",{R_:{result:"UserDefinedTemplate.Definition"}},1,0],[["category_alias","title_alias","value","units","type"],"CreatePartAttribute",{R_:{createdPartAttribute:"TaggedObject"}},5,0],[["sourcePartTag"],"CreateRelation",{},1,0],[["udfFeatureTag"],"ConvertUdfToFeaturetemplate",{},1,0],[["flexFeatureTag"],"ConvertDeformToFeaturetemplate",{},1,0],[["builder","definitionPartTag"],"SetBuilderAndDefinitionPart",{},2,0],[[],"FindDefinitionObjectInPart",{R_:{result:"UserDefinedTemplate.Definition"}},0,0],[["templateFeatureTag"],"FindInstantiationObjectFromTemplateFeature",{R_:{result:"UserDefinedTemplate.Instantiation"}},1,0]],[]];
SPLM.UserDefinedTemplate.Collection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.UserDefinedTemplate.Collection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;